import { AccountKind } from '../../Types/customerAccounts';

export const KIND_LABEL: Record<AccountKind, string> = {
  website: 'abatix.com customer',
  customer: 'SMS customer',
  worker: 'AIMS user',
};

/** Short form for table cells. */
export const KIND_SHORT: Record<AccountKind, string> = {
  website: 'abatix.com',
  customer: 'SMS',
  worker: 'AIMS user',
};

/** Local date only, e.g. "Oct 23, 2026". */
export function formatDate(value: string | null | undefined): string {
  if (!value) return '';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? value : date.toLocaleDateString(undefined, { dateStyle: 'medium' });
}

/** Local date and time, e.g. "Oct 23, 2026, 4:51 PM". Empty for a missing value. */
export function formatDateTime(value: string | null | undefined): string {
  if (!value) return '';
  const date = new Date(value);
  return Number.isNaN(date.getTime())
    ? value
    : date.toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' });
}
